<template>
    <v-container>
        <v-btn x-small :color="paymentStatusColor" dark class="ml-n3 pa-1" @click="showDialog">
            {{ localPaymentStatus }}
        </v-btn>
        <v-row justify="center">
            <v-dialog
                    persistent
                    v-model="dialog"
                    max-width="290"
                    @keydown.esc="dialog = false"
                    @keydown.enter="togglePaymentStatus"
                    @keydown.space="togglePaymentStatus"
            >
                <v-card>
                    <v-card-title class="headline">결제 상태 변경</v-card-title>
                    <v-card-text>
                        상태를 변경하시겠습니까?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="green darken-1"
                                text
                                @click="dialog = false"
                        >취소</v-btn>

                        <v-btn
                                color="green darken-1"
                                text
                                @click="togglePaymentStatus"
                        >변경</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
import axios from "axios";

export default {
    name: 'PaymentStatusButton',
    props: {
      orderId: {},
      paymentStatus: {},
      disable: {}
    },
    data() {
        return {
            localPaymentStatus: this.paymentStatus,
            paymentStatusColor: 'primary',
            dialog: false
        }
    },
    methods: {
        showDialog(event) {
            if(this.disable == true){
                return false
            }
            event.preventDefault()
            this.dialog = true
        },
        togglePaymentStatus(event) {

            if(this.disable == true){
                return false
            }

            event.preventDefault()
            this.dialog = false

            if(!this.orderId){
                alert('주문번호가 없습니다.\n개발자에게 문의하세요.')
                return false
            }

            return axios({
                method: 'POST',
                headers: {
                    'Authorization': 'bearer ' + this.$store.getters.getAccessToken
                },
                url: this.$store.getters.getApiUrl + '/api/v1/order/togglePaymentStatus/' + this.orderId,
                timeout: this.$store.getters.getApiRequestTimeLimit
            })
            .then(response => {

                if(response.data && response.data.paymentStatus != ''){

                    this.localPaymentStatus = response.data.paymentStatus
                    this.changeButtonColor()

                }

            })

        },
        changeButtonColor() {

            switch(this.localPaymentStatus){

                case '미납':
                    this.paymentStatusColor = 'pink'
                    break

                case '일부납':
                    this.paymentStatusColor = 'primary'
                    break

                case '완납':
                    this.paymentStatusColor = 'green'
                    break

                default:
                    this.paymentStatusColor = 'pink'
                    break

            }

        }
    },
    created(){
        this.changeButtonColor()
    }
}
</script>